module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['catalog', _vm.avatarIcon ? 'icon-wrapper' : 'simple-mode', _vm.hasMargin && 'catalog-margin'],
    style: {
      backgroundColor: _vm.backgroundColor
    }
  }, [(_vm.avatarIcon) ? _c('image', {
    staticClass: ["left-icon"],
    attrs: {
      "src": _vm.imagePath
    }
  }) : _vm._e(), _c('text', {
    staticClass: ["text"],
    style: _vm.textStyle
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-f0650c94!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-catalog/index.vue
// module id = 676
// module chunks = 0 1